export const isSentimentSnapshotPage = (configId: string): boolean =>
  configId === 'company-sentiment-snapshot' ||
  configId === 'industry-sentiment-snapshot' ||
  configId === 'geography-sentiment-snapshot' ||
  configId === 'role-sentiment-snapshot';
